/**
 * `<key>Du` or `<key>Sie`, by the partner's courtesy form. Anything other than `Du` - including a
 * partner with no form set - reads as the formal `Sie`.
 */
export function courtesyKey(key: string, courtesyForm: string | null | undefined): string {
  return `${key}${courtesyForm === 'Du' ? 'Du' : 'Sie'}`;
}
